import { useEffect, useState } from 'react';
import { FormInputWithValidationProps } from '../models/FormInputWithValidation';
import { SelectProps } from '../models/SelectProps';
import { generatePeriods } from '../data/generatePeriods';
import { Select } from './Select';

export const PeriodSelect = (
  props: FormInputWithValidationProps & SelectProps & Partial<HTMLElement>,
) => {
  const [periods, setPeriods] = useState([]);

  useEffect(() => {
    setPeriods(generatePeriods());
  }, []);

  return <Select options={periods} {...props} />;
};
